var _rect, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditorIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 1.5,
    width: 10,
    height: 13,
    rx: 0.5,
    stroke: "#252525"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11.5,
    width: 2,
    height: 3,
    rx: 0.5,
    stroke: "#252525"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 3,
    x2: 5,
    y2: 4,
    stroke: "#252525"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 7,
    y2: 4,
    stroke: "#252525"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 4,
    stroke: "#252525"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 3,
    x2: 11,
    y2: 4,
    stroke: "#252525"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 5,
    x2: 5,
    y2: 6,
    stroke: "#252525"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 5,
    x2: 7,
    y2: 6,
    stroke: "#252525"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 5,
    x2: 9,
    y2: 6,
    stroke: "#252525"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 5,
    x2: 11,
    y2: 6,
    stroke: "#252525"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7,
    x2: 5,
    y2: 8,
    stroke: "#252525"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 7,
    x2: 7,
    y2: 8,
    stroke: "#252525"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 7,
    x2: 9,
    y2: 8,
    stroke: "#252525"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 7,
    x2: 11,
    y2: 8,
    stroke: "#252525"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 9,
    x2: 5,
    y2: 10,
    stroke: "#252525"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 9,
    x2: 7,
    y2: 10,
    stroke: "#252525"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 9,
    x2: 9,
    y2: 10,
    stroke: "#252525"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 9,
    x2: 11,
    y2: 10,
    stroke: "#252525"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 11,
    x2: 5,
    y2: 12,
    stroke: "#252525"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 11,
    x2: 11,
    y2: 12,
    stroke: "#252525"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorIconActive);
export default __webpack_public_path__ + "static/media/editor-icon-active.32d8279a375702085cc4de5bcec1c512.svg";
export { ForwardRef as ReactComponent };